@if (lightboxConfig) {
  <div
    class="lightbox-modal"
    [style.display]="isVisible ? 'flex' : 'none'"
    (keydown.escape)="close()"
    (keydown.arrowleft)="previousImage()"
    (keydown.arrowright)="nextImage()"
    >
    <div (click)="close()" class="lightbox-clickout-area"></div>
    <div mat-button (click)="close()" class="top-menu close">
      <button type="button" mat-fab (click)="close()" class="">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>
    @if (useSrcSet) {
      <img
        class="lightbox-modal-content"
        (swipeleft)="previousImage()"
        (swiperight)="nextImage()"
        (click)="nextImage()"
        [srcset]="getSrcSetForImage(lightboxConfig.imageUrls[currentIndex])"
        [src]="lightboxConfig.imageUrls[currentIndex]"
        />
    }
    @if (!useSrcSet) {
      <img
        class="lightbox-modal-content"
        (swipeleft)="previousImage()"
        (swiperight)="nextImage()"
        (click)="nextImage()"
        [src]="lightboxConfig.imageUrls[currentIndex]"
        />
    }
    <div mat-button (click)="previousImage()" class="lightbox-nav-buttons prev">
      <button mat-fab type="button" class="mat-fab arrow-buttons left">
        <mat-icon class="mat-icon arrow-icon left">keyboard_arrow_left</mat-icon>
      </button>
    </div>
    <div mat-button (click)="nextImage()" class="lightbox-nav-buttons next">
      <button mat-fab type="button" class="mat-fab arrow-buttons right">
        <mat-icon class="mat-icon arrow-icon right">keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
}
